import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import CSSModules from "lib/utils/css-modules";

import { st, Button, SubBar, MainView, OrdersList, EditButton, FormControl } from "lib/index";
import { open as openEditCustomerModal } from "modules/customers/EditCustomerModal";
import { stateSelector, initializeView, fetchCustomer, loadCustomer } from "./index";
import styles from "./ShowCustomerView.less";

@connect(
  (state) => ({
    customer: stateSelector(state).customer.model,
    fetchDone: stateSelector(state).customer.fetchDone,
    fetchLoading: stateSelector(state).customer.fetchLoading,
    fetchFailed: stateSelector(state).customer.fetchFailed,
  }),
  (dispatch) =>
    bindActionCreators(
      {
        initializeView,
        fetchCustomer,
        loadCustomer,
        openEditCustomerModal,
      },
      dispatch
    )
)
@CSSModules(styles)
export default class ShowCustomerView extends React.PureComponent {
  componentDidMount() {
    this.props.initializeView(+this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.props.initializeView(+nextProps.params.id);
    }
  }

  handleEditCustomerClick() {
    this.props.openEditCustomerModal(this.props.customer);
  }

  renderSectionCustomerDetails() {
    const { customer } = this.props;
    return (
      <div styleName="section--customer-details">
        <div styleName="section-title">
          {customer.full_name || I18n.t("papp.customers.ShowCustomerView.no_name")}
          &nbsp;
          <EditButton onClick={this.handleEditCustomerClick.bind(this)} />
        </div>

        <div styleName="customer-metas">
          <div styleName="customer-metas-left">
            {customer.phone_number && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">phone</i>
                  <span className="text">{customer.phone_number}</span>
                </span>
              </div>
            )}
            {customer.email && (
              <div styleName="customer-meta">
                <span className="with-icon">
                  <i className="icon material-icons">email</i>
                  <span className="text">{customer.email}</span>
                </span>
              </div>
            )}
          </div>
          <div styleName="customer-metas-right">
            <div styleName="customer-meta">
              <span className="with-icon">
                <i className="icon material-icons">surround_sound</i>
                <span className="text">
                  {I18n.humanAttributeName("customer", "author_place")}: {customer.author_place}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="ui form">
          {customer.company_note && (
            <div className="customer-note">
              <FormControl.TextAreaFormGroup
                value={customer.company_note}
                label={I18n.humanAttributeName("customer", "company_note")}
                autoHeight
                readOnly
              />
            </div>
          )}
        </div>
      </div>
    );
  }

  renderSectionOrders() {
    const { customer } = this.props;
    return (
      customer.orders.length > 0 && (
        <div styleName="section">
          <div styleName="section-title">{I18n.t("papp.customers.ShowCustomerView.orders_title")}</div>
          <OrdersList orders={customer.orders} showCustomerAsFirst={false} />
        </div>
      )
    );
  }

  render() {
    const { customer, fetchDone, fetchLoading, fetchFailed, actionPending, loadCustomer, fetchCustomer } = this.props;

    return (
      <MainView.Container>
        <SubBar>
          <div className="pull-left u-flexRow">
            <h1>{I18n.t("papp.customers.ShowCustomerView.title")}</h1>
          </div>

          {fetchDone && (
            <div className="pull-right">
              {st.authorize("update", customer) && (
                <Button
                  as="a"
                  basic
                  onClick={this.handleEditCustomerClick.bind(this)}
                  disabled={actionPending}
                  content={I18n.t("papp.common.edit")}
                />
              )}
            </div>
          )}
        </SubBar>

        <MainView.Content hasSubBar>
          <MainView.Dimmer loading={fetchLoading} failed={fetchFailed} retry={fetchCustomer} />

          {fetchDone && (
            <div styleName="container">
              <div styleName="main">
                {this.renderSectionCustomerDetails()}
                {this.renderSectionOrders()}
              </div>
            </div>
          )}
        </MainView.Content>
      </MainView.Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/customers/ShowCustomerView/ShowCustomerView.jsx